<template>
  <div class="lg:px-40 lg:mt-0 mt-10 px-0">
    <!-- {{ selectedDay }} -->
    <!-- Selecione o mês e ano -->
    <div class="lg:flex lg:gap-2 lg:justify-center mb-10">
      <div class="flex-[2]">
        <div class="mx-auto">
          <!-- Selecione o mês e ano -->
          <div class="flex justify-between py-4">
            <button @click="previousMonth" class="rounded">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                class="fill-deliRed">
                <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
              </svg>
            </button>
            <div>
              <span class="text-2xl italic">
                {{ monthNames[currentMonth] }} {{ currentYear }}
              </span>
            </div>
            <button @click="nextMonth" class="rounded">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                class="fill-deliRed">
                <path d="m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z" />
              </svg>
            </button>
          </div>
          <!-- Calendário -->
          <div class="grid grid-cols-7 gap-1">
            <!-- Linha em cima dos nomes dos dias -->
            <div class="col-span-7 border-t border-deliRed"></div>

            <!-- Dias da semana -->
            <div v-for="(day, index) in daysOfWeek" :key="index" class="text-center text-lg">
              {{ day.slice(0, 1) }}
            </div>

            <!-- Linha embaixo dos nomes dos dias -->
            <div class="col-span-7 border-b border-deliRed"></div>

            <!-- Renderizar os dias do mês -->
            <div v-for="day in daysInMonth" :key="day?.date" class="cursor-pointer mx-auto"
              @click="showEventDetails(day)">
              <div class="hover:bg-deliRed hover:text-white rounded-full aspect-w-1 aspect-h-1 w-6 h-6 text-center"
                :class="{
                  'bg-deliRed hover:bg-deliRed text-white': isToday(day),
                  'border border-deliRed': hasEvent(day),
                  'hover:bg-deliYellow': !isToday(day) && !hasEvent(day),
                }">
                {{ day?.date?.getDate() }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Popup :visible="isPopupVisible" @close="isPopupVisible = false">
        <h3 class="text-2xl mb-4">{{ selectedDay.date.toLocaleDateString('en-US', {
          weekday: 'long', // Nome completo do dia da semana
          month: 'long', // Nome completo do mês
          day: 'numeric', // Número do dia
        }) }}</h3>
        <div v-for="event in selectedDay.events" :key="event.id" class="mb-10">
          <div>
            <img v-if="event?.event_image" :src="event?.event_image" alt="Event image" />
          </div>
          <div>
            <div class="py-2 text-2xl" v-html="event?.event_title"></div>
            <div>
              <span v-if="event?.occur_begin">{{ formatDateToEnglish(event.occur_begin) }}</span> - <span
                v-if="event?.event_time">{{
                  event.event_time }} - {{ event.event_endtime }}</span>
            </div>
            <div class="my-2" v-html="event?.event_short"></div>
            <div>
              <div v-for="item of event.schedule">
                <div v-if="item.time">time: {{ item.time }}</div>
                <div v-if="item.name">name: {{ item.name }}</div>
                <div v-if="item.instagram">instagram: <a class="underline" target="_blank"
                    :href="`https://instagram.com/${item.instagram.replace('@', '')}`">{{ item.instagram }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Popup>

    </div>
  </div>
</template>

<script>
import Popup from '@/components/PopupComponent.vue';
const today = new Date(); // Data atual
const currentMonth = today.getMonth();
const currentYear = today.getFullYear();
export default {
  components: {
    Popup
  },
  data() {
    return {
      isPopupVisible: false,
      currentMonth,
      currentYear,
      events: [],
      selectedDay: null,
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    };
  },
  async mounted() {
    const response = await this.$axios.get("/my-calendar/v1/events");
    this.events = response.data;
    console.log(this.events);
  },
  watch: {
    currentMonth(value) {
      console.log("change current month", value);
    }
  },
  computed: {
    // Computa os dias do mês
    daysInMonth() {
      const date = new Date(this.currentYear, this.currentMonth, 1);
      const days = [];

      // Encontrar o primeiro dia do mês
      const firstDay = date.getDay();

      // Preencher os dias do mês
      const lastDayOfMonth = new Date(
        this.currentYear,
        this.currentMonth + 1,
        0
      ).getDate();

      for (let i = 0; i < firstDay; i++) {
        days.push(null);
      }

      for (let i = 1; i <= lastDayOfMonth; i++) {
        const day = new Date(this.currentYear, this.currentMonth, i);
        days.push({
          date: day,
          events: this.getEventsForDate(day),
        });
      }

      return days;
    },
  },
  methods: {
    // Verifica se o dia é o atual
    isToday(day) {
      const today = new Date();
      const result =
        today.getDate() === day?.date?.getDate() &&
        today.getMonth() === day?.date?.getMonth() &&
        today.getFullYear() === day?.date?.getFullYear();
      return result;
    },
    // Verifica se existe algum evento para a data
    hasEvent(day) {
      return day?.events && day?.events?.length > 0;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Adiciona zero à esquerda, se necessário
      const day = String(date.getDate()).padStart(2, '0'); // Adiciona zero à esquerda, se necessário

      return `${year}-${month}-${day}`;
    },
    // Obtém os eventos de uma data específica
    getEventsForDate(day) {
      try {
        return this.events[this.formatDate(day)];
      } catch (error) {
        return [];
      }
    },
    // Exibe o modal de detalhes do evento
    showEventDetails(day) {
      if (day.events.length === 0) return;
      this.isPopupVisible = true;
      this.selectedDay = day;
    },
    // Mudar para o próximo mês
    nextMonth() {
      if (this.currentMonth === 11) {
        this.currentMonth = 0;
        this.currentYear++;
      } else {
        this.currentMonth++;
      }
    },
    // Mudar para o mês anterior
    previousMonth() {
      if (this.currentMonth === 0) {
        this.currentMonth = 11;
        this.currentYear--;
      } else {
        this.currentMonth--;
      }
    },
    formatDateToEnglish(date) {
      const dateAux = new Date(date);
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      return new Intl.DateTimeFormat("en-US", options).format(dateAux);
    },
  },
};
</script>
<style scoped>
a {
  text-decoration: underline;
}
</style>
